export const SET_USERS_CHARTS = 'SET_USERS_CHARTS';
export const SAVE_USER_CHARTS = 'SAVE_USER_CHARTS';
export const SET_CHART = 'SET_CHART';
export const SET_CHART_TYPE = 'SET_CHART_TYPE';
export const REMOVE_USER_CHART = 'REMOVE_USER_CHART';